import { Outlet } from "react-router";

export default function GfsCalculationsRoute() {
  return <Outlet />;
}
